import { BestPEOComparison } from "@/components/content/BestPEOComparison";
import { EnhancedFAQs } from "@/components/seo/EnhancedFAQs";
import { MetaManager } from "@/components/seo/MetaManager";
import { MainNavigation } from "@/components/layout/MainNavigation";
import { Footer } from "@/components/layout/Footer";

const COMPARISON_FAQS = [
  {
    question: "How do you rank the best PEO companies?",
    answer: "We evaluate PEOs based on multiple factors including ESAC accreditation, customer satisfaction scores, service quality, technology platforms, pricing transparency, compliance track record, and industry expertise. Our rankings are based on extensive research and are updated regularly to reflect current market conditions."
  },
  {
    question: "What makes a PEO better than others?",
    answer: "The best PEOs combine strong financial stability (preferably ESAC accredited), excellent customer service, competitive pricing, robust technology platforms, comprehensive compliance support, and industry-specific expertise. They should also have transparent pricing and strong client retention rates."
  },
  {
    question: "Should I choose the #1 ranked PEO for my business?",
    answer: "Not necessarily. While our rankings provide valuable guidance, the best PEO for your business depends on your specific needs, industry, size, and location. A smaller PEO might be better for very small businesses, while larger companies may need enterprise-level features. Use our free matching service to find the best fit."
  },
  {
    question: "How often do these PEO rankings change?",
    answer: "We update our rankings quarterly or when significant changes occur in the industry. PEO performance can change due to new technology implementations, service improvements, pricing changes, or market conditions. We monitor customer feedback and industry developments continuously."
  },
  {
    question: "Are these PEO reviews sponsored or biased?",
    answer: "No, our reviews and rankings are completely independent and unbiased. We do not accept payment for rankings or reviews. While we earn commissions when businesses choose PEO providers through our platform, this does not influence our editorial content or rankings methodology."
  }
];

export const BestPEOProviders = () => {
  return (
    <div className="min-h-screen bg-background">
      <MetaManager
        title="Best PEO Companies 2025: Top Professional Employer Organizations Ranked"
        description="Expert rankings and reviews of the best PEO companies in 2025. Compare top Professional Employer Organizations by pricing, services, and customer satisfaction. Find the perfect PEO for your business with our unbiased analysis."
        keywords="best PEO companies, top PEO providers, PEO rankings 2025, professional employer organization reviews, PEO comparison, ESAC accredited PEOs"
        canonical="https://thepeoapp.com/best-peo-providers"
      />
      
      <MainNavigation />
      
      <main className="pt-16">
        <div className="container mx-auto px-4 py-12">
          <BestPEOComparison />
          
          <div className="mt-16">
            <EnhancedFAQs 
              title="Best PEO Companies FAQ"
              faqs={COMPARISON_FAQS}
              showSchema={true}
            />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};